<template>
    <div id="content-khs">
        <v-expand-transition>
            <div :v-show="show">
                <v-divider></v-divider>
                <v-card class="v-card-krs mx-auto mb-4">
                            <v-divider></v-divider>
                            <v-card-text>
                                <div class="row">
                                    <div class="col-md-12 offsets-md-6">
                                        <router-link :to="{path: '/penilaian-siswa/kartu-hasil-studi'}">
                                            <b-button variant="outline-danger" class="mt-2 ml-2 float-right">Back</b-button>
                                        </router-link>
                                    <ButtonComponent colors="#3751E4" name="print" :dataTitleTooltip="'Export To PDF'"
                                        @click.native="downloadAsPDF(datasiswa.student_name)" class="mt-2 ml-2 float-right" />
                            </div>
                                </div>
                                
                                <div class="row" :id="'pdf-content-print-'+datasiswa.student_name">
                                    <div class="col-12 text-center mb-4">
                                        <h2 class="font-weight-bold text-uppercase" style="font-size: 2.5rem;">
                                            Kartu Hasil Studi (KHS)
                                        </h2>
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col-4 offset-1">
                                            <img src="media/logos/LOGO-AKMIL-KEP-357-27-JUNI-2023-.png" style="max-width: 50%;height: auto;display: block;padding-right: 48px;width: auto;min-width: 200px;float: inline-end;" />
                                        </div>
                                        <div class="col-6 font-weight-bold" style="font-size: 16px">
                                            <div class="row p-0">
                                                <div class="col-4 p-1">
                                                    NAMA
                                                </div>
                                                <div class="col-8 p-1">
                                                    : {{ datasiswa?.student_name ?? '-' }}
                                                </div>
                                            </div>
                                            <div class="row p-0">
                                                <div class="col-4 p-1">
                                                    KORPS/KELAS
                                                </div>
                                                <div class="col-8 p-1">
                                                    : {{ datasiswa?.student_korps ?? '-' }}/{{ datasiswa?.student_class ?? '-' }}
                                                </div>
                                            </div>
                                            <div class="row p-0">
                                                <div class="col-4 p-1">
                                                    NOMOR AKADEMIK
                                                </div>
                                                <div class="col-8 p-1">
                                                    : {{ datasiswa?.student_nim ?? '-' }}
                                                </div>
                                            </div>
                                            <div class="row p-0">
                                                <div class="col-4 p-1">
                                                    TINGKAT
                                                </div>
                                                <div class="col-8 p-1">
                                                    : {{ datasiswa.student_tingkat }}
                                                </div>
                                            </div>
                                            <div class="row p-0">
                                                <div class="col-4 p-1">
                                                    SEMESTER
                                                </div>
                                                <div class="col-8 p-1">
                                                    : {{ datasiswa.student_semester }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-12 p-2 mt-4">
                                        <h4 class="title-bold">
                                            I. Akademik
                                        </h4>
                                    </div>
                                    <div class="col-12">
                                        <table border="1" style="width: 100%">
                                            <thead class="text-center">
                                                <tr>
                                                    <th rowspan="2" width="5%" style="font-size: 16px">
                                                        NO
                                                    </th>
                                                    <th rowspan="2" width="50%" style="font-size: 16px">
                                                        MATA PELAJARAN
                                                    </th>
                                                    <th rowspan="2" width="10%" style="font-size: 16px">
                                                        SKS
                                                    </th>
                                                    <th colspan="2" width="13%" style="font-size: 16px">
                                                        NILAI
                                                    </th>
                                                    <th rowspan="2" width="14%" style="font-size: 16px">
                                                        NILAI X SKS
                                                    </th>
                                                    <th rowspan="2" style="font-size: 16px">
                                                        KET
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>A-E</th>
                                                    <th>0-4.00</th>
                                                    <!-- Add more subheaders as needed -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <!-- Add table rows here -->
                                                <tr v-if="akademik.data.length < 1
                                                    " class="text-center">
                                                    <td rowspan="6">
                                                        -- No Data Available --
                                                    </td>
                                                </tr>
                                                <tr v-for="(
                                                        nilai, index
                                                    ) in akademik.data" :key="index">
                                                    <td class="text-center" style="font-size: 16px">
                                                        {{ nilai.no }}
                                                    </td>
                                                    <td class="pl-1" style="font-size: 16px">
                                                        {{ nilai.mapel }}
                                                    </td>
                                                    <td class="text-center" style="font-size: 16px">
                                                        {{ nilai.sks }}
                                                    </td>
                                                    <td class="pl-1" style="font-size: 16px;">
                                                        {{ nilai.predikat }}
                                                    </td>
                                                    <td class="text-center" style="font-size: 16px">
                                                        {{ nilai.ip }}
                                                    </td>
                                                    <td class="text-center" style="font-size: 16px">
                                                        {{ nilai.nxsks }}
                                                    </td>
                                                    <td class="text-center" style="font-size: 16px"></td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td class="text-center" style="font-size: 16px">
                                                        Total
                                                    </td>
                                                    <td class="text-center" style="font-size: 16px">
                                                        {{ datasiswa.jumlah_sks }}
                                                    </td>
                                                    
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="row mt-1">
                                            <div class="col-7">
                                                <p class="txt-sub-table">
                                                    Indeks Prestasi (IP) Semester
                                                    
                                                    {{ datasiswa.student_semester }} :
                                                </p>
                                            </div>
                                            <div class="col-3 offset-2 text-center font-weight-bold" style="
                                                    font-size: 16px;
                                                    padding-right: 84px;
                                                ">
                                                {{ datasiswa.nakhir }}
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </v-card-text>
                </v-card>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
// import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import html2canvas from 'html2canvas';
import axios from 'axios';
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
    name: 'StudentKHS',
    props : {
        dataEdit: {
            type : Object,
        }
        
    },  

    data() {
        return {
           
            show: false,
            tingkat: null,
            key_siswa: null,
            // dataDetailKHS: [],
            semesterCollapse: null,
            datasiswa: [],
            akademik: {
                headers: [
                    [
                        {
                            text: 'No',
                            align: 'start',
                            sortable: false,
                            value: 'no',
                            rowspan: 2,
                        },
                        {
                            text: 'Mata Pelajaran',
                            align: 'start',
                            sortable: false,
                            colspan: 5,
                            value  : 'mapel',
                            isSubHeader: true,
                        },
                        {
                            text: 'SKS',
                            align: 'start',
                            sortable: false,
                            colspan: 5,
                            isSubHeader: true,
                        },
                        {
                            text: 'Nilai',
                            align: 'start',
                            sortable: false,
                            colspan: 5,
                            isSubHeader: true,
                        },
                        {
                            text: 'IP',
                            align: 'end',
                            sortable: false,
                            value: 'ip',
                            rowspan: 2,
                        },
                    ],
                    [
                        { text: 'A-E', align: 'end', value: 'predikat' },
                        { text: '0-4.00', align: 'end', value: 'ip' },
                    ],
                ],
                data: [],
            },
           
            
        };
    },

    mounted() {
        this.getDataDetailKHS()
    },

    components: {
        ButtonComponent
    },

    methods: {
        downloadAsPDF(student_name) {
            const divToPrint = document.getElementById('pdf-content-print-'+student_name);

            var options= {
                width: 1920,
                height: 1280,
                windowHeight: 1280,
                windowWidth: 1920,
                scale: 5,
            };
            // Konversi div ke gambar (PNG)
            html2canvas(divToPrint, options).then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    // Dokumen PDF
                    const pdfWidth = 550; // A4 width in mm
                    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                    const docDefinition = {
                        content: [
                            {
                                image: imgData,
                                width: pdfWidth, // Sesuaikan dengan lebar gambar
                                height: pdfHeight, // Sesuaikan dengan tinggi gambar
                                alignment: 'center',
                            },
                        ],
                        pageSize: 'A4', // Set a fixed paper size (A4 in this case)
                        pageMargins: [160, 60, 40, 60], // Set fixed page margins [left, top, right, bottom]
                    };

                    // Buat PDF
                    pdfMake
                        .createPdf(docDefinition)
                        .download(
                            `KHS-${student_name}-Semester ${this.dataDetailKHS.student_semester}.pdf`
                        );
                })
                .catch((err) => {
                    throw err;
                });
        },

        async getDataTingkat() {
            // Define the mapping of semester to "Tingkat"
            const arr = [
                { id: '[1,2]', text: 'Tingkat I' },
                { id: '[3,4]', text: 'Tingkat II' },
                { id: '[5,6]', text: 'Tingkat III' },
                { id: '[7,8]', text: 'Tingkat IV' },
            ];

            // Generate the listTingkat based on the unique semester values
            const tingkats = arr.find((tngk) =>
                tngk.id.includes(this.semester)
            );
            this.tingkat = tingkats.text;
            // this.listTingkat = uniqueSemesters.map(semester => {
            //     const tingkatInfo = arr.find(item => item.id.includes(semester));
            //     return { id: tingkatInfo.id, text: tingkatInfo.text };
            // });
        },

        formatFloatToThreeDecimals(num) {
            var validnum = num ?? 0;
            const [whole, decimal] = validnum.toString().split('.');

            // If there are more than 2 decimal places, truncate to 3
            let truncatedDecimal = decimal ? decimal.slice(0, 3) : '000';
            if (truncatedDecimal.length === 1) {
                truncatedDecimal += '00';
            } else if (truncatedDecimal.length === 2) {
                truncatedDecimal += '0';
            }
            // Concatenate the whole and truncated decimal parts
            return `${whole}.${truncatedDecimal}`;
        },

        formatFloatToTwoDecimals(num) {
            var validnum = num ?? 0;
            const [whole, decimal] = validnum.toString().split('.');

            // If there are more than 2 decimal places, truncate to 2
            let truncatedDecimal = decimal ? decimal.slice(0, 2) : '00';
            if (truncatedDecimal.length === 1) {
                truncatedDecimal += '0';
            }
            // Concatenate the whole and truncated decimal parts
            return `${whole}.${truncatedDecimal}`;
        },


    

        async getDataDetailKHS() {

            let id_siswa = this.$route.params.id;

            await axios
                .get(`khs/ip_siswa/${id_siswa}`)
                .then((res) => {
                    if (res.data.meta.code === 409) {
                        this.dataDetailKHS = [];
                    } else if (res.data.meta.code === 200) {
                        this.dataDetailKHS = res.data.data;
                    }
                    this.akademik.data = []
                   
                 
                    // This for mapping data matkul to data akademik for table
                    this.dataDetailKHS.khs.map((hasil, index) => {
                        
                        let khss = {
                            no: index + 1,
                            mapel: hasil.course_name,
                            sks: hasil.credits ? hasil.credits : 0,
                            ip: this.formatFloatToTwoDecimals(
                                hasil.nilai.nilai_akhir
                            ),
                            predikat: hasil.nilai.predikat,
                            nxsks: this.formatFloatToTwoDecimals(
                                hasil.nilai.nilai_asli
                            ),
                        };
                        this.akademik.data.push(khss);
                    });

                    // Mapping data diri siswa
                    this.datasiswa = {
                        student_name        : this.dataDetailKHS.student_name,
                        student_nim         : this.dataDetailKHS.student_nim,
                        student_tingkat     : this.dataDetailKHS.student_tingkat,
                        student_semester    : this.dataDetailKHS.student_semester,
                        jumlah_sks          : this.dataDetailKHS.jumlah_sks,
                        nakhir              : this.dataDetailKHS.nakhir,
                        student_class       : this.dataDetailKHS.student_class,
                        student_korps       : this.dataDetailKHS.student_korps
                    }

                })
                .catch((err) => {
                    throw err;
                });
        },

        
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    computed: {
       
        isMediumScreen() {
            return window.innerWidth >= 768 && window.innerWidth < 992;
        },
        isLargeScreen() {
            return window.innerWidth >= 992;
        },
    },
};
</script>

<style lang="scss" scoped>
/* Default styles for all screen sizes */
.my-element {
    width: 100%;
    /* Default to 100% width */
    height: auto;
}

/* Styles for large screens (Xl) */
@media (min-width: 2560px) {
    .my-element {
        width: 30%;
        /* Adjust to 25% width on large screens */
        height: auto;
    }
}

/* Styles for large screens (lg) */
@media (max-width: 2559px) {
    .my-element {
        width: 40%;
        /* Adjust to 25% width on large screens */
        height: auto;
    }
}

/* Styles for medium-sized screens (md) */
@media (max-width: 1199px) {
    .my-element {
        width: 80%;
        /* Adjust to 50% width on medium-sized screens */
        height: auto;
    }
}

table{
    border-collapse: collapse;
}

.txt-bottom {
    padding-bottom: 0;
}

.txt-top {
    padding-top: 0;
}

.txt-sub-table {
    font-size: 16px;
    margin-bottom: 2px !important;
    font-weight: bold;
}

.fnt {
    font-size: 1.2rem;
    font-weight: bold;
}

table>thead>tr>th {
    font-size: 1rem;
}

span {
    font-size: 1rem;
}

.title-bold{
    font-weight: 700 !important;
}

/* Styles for small screens (sm) */
// @media (max-width: 768px) {
//     .my-element {
//         width: 75%; /* Adjust to 75% width on small screens */
//         height: auto;
//   }
// }
</style>
